import { gql } from "@apollo/client";
import { createAction } from "@logicsoftware/redux-toolkit";
import { put, select, takeLeading } from "redux-saga/effects";
import { DetailsId } from "~/EasyProjects/Details/DetailsId";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { callApi } from "~/Redux/Sagas/effects/callApi";
import { getSpaceByDetailsId } from "~/Redux/Spaces/state/sagas/getSpaceIdByDetails";
import { getSpaceMembersByProject, setSpaceMembersByProject } from "./slice";
import { SpaceMembers } from "./types";

type Payload = {
    projectId: number;
    forceReload?: boolean;
};

export const loadSpaceMembersByProject = createAction<Payload>("spaceMembersByProject/loadSpaceMembersByProject");

export function* loadSpaceMembersWatcher() {
    yield takeLeading(loadSpaceMembersByProject, function* ({ payload: { projectId, forceReload } }) {
        const existingData: SpaceMembers = yield select(getSpaceMembersByProject(projectId));
        if (existingData && !forceReload) {
            return;
        }

        const spaceId: number = yield getSpaceByDetailsId(DetailsId.forProject(projectId));
        const { data }: { data: SpaceMembersResponse } = yield callApi(() => getSpaceMembersApi(spaceId));
        const spaceMembers = data.byId.members.map(m => m.userId);
        yield put(setSpaceMembersByProject({ projectId, spaceMembers }));
    });
}

export type SpaceMembersResponse = {
    byId: {
        spaceId: number;
        canInviteUsers: boolean;
        members: { userId: number }[];
    };
};

export const getSpaceMembersApi = (spaceId: number) =>
    OAuthClient.graphql<SpaceMembersResponse>(appUrls.spaces.graphql, {
        query: gql`
            query GetSpaceDetails($spaceId: Int!) {
                byId(id: $spaceId) {
                    spaceId
                    canInviteUsers
                    members {
                        userId
                    }
                }
            }
        `,
        variables: { spaceId },
    });
